import { Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import { CONTRACTAREASTATUS_CONFIG, CONTRACTAREASTATUS_FIELDS } from './contract-area-status.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { ContractAreaStatusService } from '../proxy/controlling/controllers';
import { ContractAreaStatusCreateDto, ContractAreaStatusDto, ContractAreaStatusExcelDownloadDto, ContractAreaStatusUpdateDto } from '../proxy/controlling/dtos/contract-area-status';

@Component({
  selector: 'app-contract-area-status',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ContractAreaStatusService, ConfirmationService],
  templateUrl: './contract-area-status.html',
  styleUrl: './contract-area-status.scss',
})
export class ContractAreaStatus extends BaseCrudComponent<
  ContractAreaStatusDto,
  ContractAreaStatusCreateDto,
  ContractAreaStatusUpdateDto,
  ContractAreaStatusExcelDownloadDto
> {
  service = inject(ContractAreaStatusService);
  config = CONTRACTAREASTATUS_CONFIG;
  fields = CONTRACTAREASTATUS_FIELDS;

  protected prepareUpdateDto(data: any, selected: ContractAreaStatusDto): ContractAreaStatusUpdateDto {
    return {
      name: data.name,
      defaultYear: data.defaultYear,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ContractAreaStatus';
  }
}
